<template>
	<expand-list-modal
		ref="$modal"
		title="Холдинг"
		placeholder="Название или адрес"
		:filter="filter"
		@update:filter="filter = $event"
	>
		<template #summary>
			[Выручка <span :style="{ margin: '0 1px' }">/</span> Долг:
			{{ (client?.UnionRevenue ?? 0).toLocaleString('ru-RU') }}
			<span :style="{ margin: '0 1px' }">/</span>
			<span class="holding-expand__debt">{{ (client?.UnionDebt ?? 0).toLocaleString('ru-RU') }}</span>]
		</template>

		<div
			v-if="!filteredClients.length"
			class="holding-expand__empty"
		>
			Ничего не найдено
		</div>

		<div
			v-for="(uc, index) in filteredClients"
			:key="uc.Id"
			class="holding-expand__row"
		>
			<div class="holding-expand__row-left">
				<div class="holding-expand__row-count">{{ index + 1 }}.</div>
				<div class="holding-expand__row-name">
					<router-link
						class="holding-expand__row-name-str"
						:to="{ query: { page: 'client', id: uc.Id } }"
						@click="onClose"
					>
						{{ uc.Name }}
					</router-link>
					<span class="holding-expand__row-address">
						({{ uc.Address }})
						<app-tooltip
							v-if="canEdit"
							text="Удалить"
						>
							<template #activator>
								<app-icon
									class="holding-expand__row-icon"
									:style="{ marginTop: '-2px' }"
									name="close-bold"
									width="12px"
									color="#D2D2D2"
									hover-color="#BA4C4C"
									cursor="pointer"
									@click="onDetach(uc.Id)"
								/>
							</template>
						</app-tooltip>
					</span>
				</div>
			</div>
		</div>
	</expand-list-modal>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import ExpandListModal from "@/components/common/modal/ExpandListModal.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import { clientPageStore } from "@/store/client-page";

const clientStore = clientPageStore()

const client = computed(() => clientStore.openedClient)
const canEdit = computed(() => client.value?.UnionAccess === 2)

const filter = ref('')

const filteredClients = computed(() => {
	const list = client.value?.UnionClients ?? []
	const q = filter.value.trim().toLowerCase()
	if (!q) {
		return list
	}
	return list.filter((uc: any) =>
		`${uc.Name ?? ''} ${uc.Address ?? ''}`.toLowerCase().includes(q)
	)
})

const $modal = ref<InstanceType<typeof ExpandListModal> | null>(null)

const onOpen = () => {
	filter.value = ''
	$modal.value?.onOpen()
}
const onClose = () => $modal.value?.onClose()

const onDetach = async (id: number) => {
	try {
		await clientStore.detachClientFromUnion(id)
	} catch (e) {
		console.error(e)
	}
}

defineExpose({ onOpen, onClose })
</script>

<style scoped lang="scss">
.holding-expand {
	&__debt {
		color: #D05A4F;
	}

	&__empty {
		font-size: 14px;
		line-height: 18px;
		color: #979797;
		padding: 4px 0;
	}

	&__row {
		display: flex;
		align-items: center;
		justify-content: space-between;

		&-left {
			display: flex;
			align-items: center;
			font-size: 14px;
			line-height: 18px;
			gap: 2px;
		}

		&-count {
			margin: 0 2px 0 3px;
			color: #4D4D4D;
		}

		&-name {
			color: #4D4D4D;

			&-str {
				color: #4D4D4D;
				text-decoration: none;

				&:hover {
					color: #499259;
				}
			}
		}

		&-address {
			white-space: nowrap;
			color: #4D4D4D;
		}
	}
}
</style>
